import { render, staticRenderFns } from "./product-discount-modal.vue?vue&type=template&id=4bd42cda&"
import script from "./product-discount-modal.vue?vue&type=script&lang=js&"
export * from "./product-discount-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports